<template>
  <header class="fd-header">
    <div class="navbar-content">
      <div class="navbar-title-block">
        <div class="navbar-text">{{ title }}</div>
        <div v-if="showWelcome && userFirstName" class="navbar-subtext">
          Welcome back, {{ userFirstName }}!
        </div>
        <Links v-if="showCrumbs" />
      </div>
      <div class="navbar-right-sec">
        <DashboardModeSwitch v-if="showDashboardSwitch" />
        <div class="navbar-tenant-logo">
          <v-img v-if="tenantHeaderLogo" :src="tenantHeaderLogo" alt="tenant logo" />
          <div v-else class="navbar-tenant-logo-placeholder-wrap">
            <span class="navbar-tenant-logo-placeholder">Your Logo Here</span>
            <img :src="tenantLogoMark" alt="" class="navbar-tenant-logo-mark" width="32" height="32" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import Links from "@/components/layout/Common/Links.vue";
import DashboardModeSwitch from "@/components/layout/Dashboard/DashboardModeSwitch.vue";
import { useTenant } from "@app/composables/useTenant";
import { usePageMeta } from "@app/composables/usePageMeta";

const route = useRoute();
const { userFirstName, tenantName } = useTenant();
const { title, showWelcome, showCrumbs } = usePageMeta();

const showDashboardSwitch = computed(() => {
  const path = (route.path || "").toLowerCase();
  if (path.includes("/agentic-dashboard")) {
    return route.name !== "AgenticDashboardView";
  }
  return path.includes("/dashboards");
});

const tenantLogoMark = require("@/assets/Images/LeftMenu/logoicon-dark.png");

const tenantHeaderLogo = computed(() => {
  if (tenantName.value === "ExxonMobil") {
    return require("@/assets/Svg/LeftMenu/exxonLogo.svg");
  }
  if (tenantName.value === "adnoc_demo") {
    return require("@/assets/Svg/LeftMenu/adnocExpand.svg");
  }
  return null;
});
</script>
